import { Theme, css } from '@emotion/react';

export const dialogContentStyles = ({ spacing, colors }: Theme) => css`
  padding: ${spacing(3)}px;
  border-top: 1px solid ${colors.borderDefault};
  border-bottom: 1px solid ${colors.borderDefault};
`;
